import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface PageHeaderProps {
  title: string
  description?: string
  children?: ReactNode
}

export function PageHeader({ title, description, children }: PageHeaderProps) {
  return (
    <div className="border-b border-border bg-card">
      <div className="px-4 md:px-8 py-5">
        <div className={cn(
          "flex",
          children ? "flex-col gap-3 md:flex-row md:items-center md:justify-between" : "items-center justify-between"
        )}>
          <div>
            <h1 className="text-xl font-semibold tracking-tight text-foreground">
              {title}
            </h1>
            {description && (
              <p className="mt-0.5 text-[13px] text-muted-foreground">{description}</p>
            )}
          </div>
          {children && (
            <div className="flex flex-wrap items-center justify-end gap-2">{children}</div>
          )}
        </div>
      </div>
    </div>
  )
}

interface PageContentProps {
  children: ReactNode
  className?: string
}

export function PageContent({ children, className = '' }: PageContentProps) {
  return (
    <div className={cn("px-4 md:px-8 py-6", className)}>
      {children}
    </div>
  )
}
